import "babel-polyfill";
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";
import "./libs/slick.js";

import {binder} from "./libs/binder";
import {constants} from "./modules/module";
import headerNav from "./modules/header-nav";
import customSelect from "./modules/custom-select";
import customInputFile from "./modules/custom-input-file";
import inputMaxCharacters from "./modules/input-max-characters";
import {animationsBg} from "./modules/animationsBg";
import newsSlider from "./modules/news-slider";
import stickyShare from "./modules/sticky-share";
import filterBlock from "./modules/filter";
import portfolioSlider from "./modules/portfolio-slider";
import forEachPolyfill from "./modules/foreach-polyfill";

binder({
    bounds: {
        "html": [constants, forEachPolyfill],
        ".header": headerNav,
        "select": customSelect,
        ".upload-file": customInputFile,
        ".form-item": inputMaxCharacters(".max-length-validation", "textarea, input", ".characters"),
        ".animation-bg": animationsBg,
        ".news-slider": newsSlider(".news-slider"),
        ".article-share": stickyShare,
        ".filter": filterBlock,
        ".portfolio-slider": portfolioSlider(".portfolio-slider", ".portfolio-slider-nav"),
    },
    runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js